import createSvgIcon from '../createSvgIcons'

/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  <path d="M12.4516 14.8014C12.207 15.0662 11.793 15.0662 11.5484 14.8014L7.16886 10.0594C6.79788 9.65774 7.07825 9 7.62046 9H16.3795C16.9217 9 17.2021 9.65774 16.8311 10.0594L12.4516 14.8014Z" />,
  'CaretDown'
)
